import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const tabListClasses = tv({
  base: [
    "Tab__List",
    "relative",
    "z-0",
    "flex",
    "gap-1",
    "p-1",
    "rounded-xl",
    "sm:outline",
    "sm:outline-1",
    "outline-gray-300",
    "sm:bg-common-white",
  ],
  variants: {},
});
export const tabIndicatorClasses = tv({
  base: [
    "Tab__Indicator",
    "h-[calc(var(--active-tab-height))]",
    "absolute",
    "top-1/2",
    "left-0",
    "z-[-1]",
    "w-[var(--active-tab-width)]",
    "-translate-y-1/2",
    "translate-x-[var(--active-tab-left)]",
    "rounded-lg",
    "bg-primary-light/25",
    "transition-all",
    "duration-300",
    "ease-in-out",
  ],
  variants: {},
});

export type TabListVariants = VariantProps<typeof tabListClasses>;
